export default {
      id: "marker-usage",
      viewBox: "0 0 24 32",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#marker",
      toString: function () {
        return this.url;
      }
    }